import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { LogoutService } from 'src/app/services/logout.service';

@Component({
  standalone: false,
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(private readonly route: Router, private readonly c: CommonsService, private logout: LogoutService) { }

  ngOnInit() {

  }
  goToUrl(view, disconnect) {
    if (view && !disconnect) {
      this.c.eventsAnalitics('click', 'Navbar Menu', view);
      this.route.navigateByUrl('global-position/' + view);
    } else if (view && disconnect) {
      this.c.eventsAnalitics('click', 'Navbar Menu', 'Log Out');
      this.logout.logOutService().subscribe(d => {
        if (d) {
          sessionStorage.clear();
          this.route.navigateByUrl('home');
        }
      });
    } else {
      this.c.eventsAnalitics('click', 'Navbar Menu', 'main');
      this.route.navigateByUrl('global-position');
    }
  }
}
